export const APP_NAME = 'Nexile App'
export const PERSIST_STORE_NAME = '__nex_p'
export const REDIRECT_URL_KEY = 'redirectUrl'
